export const randomNumber = (min: number, max: number) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

export const getClampLevelFn =
    (factor = 1) =>
    (level: number) =>
        Math.round(level / factor) / 100;
